export default {
  routes: [
    {
      name: 'devNavigation',
      path: '/development',
      component: () => import('./views/DevNavigation.vue')
    },
  ]
}
